import { render, staticRenderFns } from "./ScoreTotalsCard.vue?vue&type=template&id=99842d4a&scoped=true&"
import script from "./ScoreTotalsCard.vue?vue&type=script&lang=js&"
export * from "./ScoreTotalsCard.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTotalsCard.vue?vue&type=style&index=0&id=99842d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99842d4a",
  null
  
)

export default component.exports